import { entrust } from "../../components/generico/utils/UrlAPI";
import AuthService from "../login/auth.service";
import axios from "axios";

class SoftTokenService {

  getDeviceFingerprint() {
    try {

      const fingerprint = window.machineSecret.getDeviceFingerprint();

      const objFingerprint = JSON.parse(fingerprint);

      delete objFingerprint.attributes.plugins;

      const newFingerprint = JSON.stringify(objFingerprint);

      const fingerprintFormatted = newFingerprint.toLowerCase().replace("format","fmt");

      return fingerprintFormatted;

    } catch (error) {
      console.error(error);
    }
  }

  async iniciarTokenPush(tokenCu24) {
    var data = JSON.stringify({
      fingerprint: this.getDeviceFingerprint()
    });

    var config = {
      method: "post",
      url: entrust + "transactions/iniciar-tokenpush",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + tokenCu24,
      },
      data: data,
    };

    return await axios(config);
  }

  async getTokenPushState(challengeToken, nroCedula) {
    var data = JSON.stringify({
      token: challengeToken,
      fingerprint: this.getDeviceFingerprint(),
      nroCedula
    });

    var config = {
      method: "post",
      url: entrust + "transactions/tokenpush-state",
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    return await axios(config);
  }

  async obtenerMetodoLogin(nroCedula) {

    var config = {
      method: "get",
      url: entrust + "transactions/metodo-login",
      headers: { "Content-Type": "application/json" },
      params: { nroCedula, canal: "WEB" }
    };

    return await axios(config);
  }

  async validarOtpToken(otp) {
    var data = JSON.stringify({
      canal: "WEB",
      fingerprint: this.getDeviceFingerprint(),
      otp: otp
    });

    var config = {
      method: "post",
      url: entrust + "transactions/token-complete",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }
}

export default new SoftTokenService();